<template>
  <!-- 公共的banner -->
  <div class="cmp-banner">
    <img :src="bannerObj[bannerType]" alt="">

    <div class="g-banner-title">
      <h1>{{titleObj[bannerType]}}</h1>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bannerType: {
      type: String,
      default: '5'  // 1导览   2展览  3藏品 4教育 5学术 6文创 7关于 8文物鉴定 9视频资源 10通知公告
    },
  },
  data() {
    return {
      // imgUrl: require('@images/banner6.png'),
      bannerObj: {
        '1': require('@images/pic_banner_museum.png'),
        '2': require('@images/pic_banner_exhibition.png'),
        '3': require('@images/banner-collect.jpg'),
        '4': require('@images/pic_banner_education.png'),
        '5': require('@images/banner-research.jpg'),
        '6': require('@images/banner-creative.jpg'),
        '7': require('@images/banner-about.jpg'),
        '8': require('@images/banner-identify.jpg'),
        '9': require('@images/banner-video.jpg'),
        '10': require('@images/banner-notice.jpg'),
      },
      titleObj: {
        '1': '导览',
        '2': '展览',
        '3': '藏品',
        '4': '教育',
        '5': '学术',
        '6': '文创',
        '7': '关于',
        '8': '民间文物鉴定',
        '9': '视频资源',
        '10': '通知公告',
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.cmp-banner {
  
}
</style>
